'use strict';

/* global angular */

// --- Dialog

angular.module('dash.inviteToSite.dialog', [])
.controller('InviteToSitePromptDialogController', require('./dialog/InviteToSitePromptDialogController'))
.directive('inviteToSitePromptDialog', require('./dialog/InviteToSitePromptDialogDirective'));

// --- Invite

angular.module('dash.inviteToSite', ['dash.inviteToSite.dialog'])
.controller('InviteToSiteController', require('./InviteToSiteController'))
.directive('inviteToSite', require('./InviteToSiteDirective'))
.factory('InviteToSiteActions', require('./InviteToSiteActions'))
.factory('InviteToSiteStore', require('./InviteToSiteStore'))
.run(['InviteToSiteStore', function (InviteToSiteStore) {
  InviteToSiteStore.init();
}]);



// WEBPACK FOOTER //
// ./src/app/dash/invite/index.js